import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ButtonV1 from "../../toolkit/ButtonV1";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import { TextField, Chip, Paper } from "@mui/material";
import List from "@mui/material/List";
import { useEffect, useRef } from "react";
import { ThemeProvider } from "@mui/material";
import baseTheme from "../../themes/baseTheme";
import PageTitleBar from "../../components/PageTitleBar";
import EmptyComponent from "../../utils/EmptyComponent";
import { Card } from "react-bootstrap";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import QuestionsBankListItem from "./QuestionsBankListItem";
import BaseURL from "../../utils/base-uri.json";
import axios from "../../utils/fvAxios";
import { useLayoutEffect } from "react";
import useFetch from "../../utils/useFetch";
import _ from "lodash";
import { e } from "mathjs";
import Divider from "@mui/material/Divider";
import AddQuestionBankDialog from "./question-bank/AddQuestionBankDialog";
const pageSize = 20;
let searchValueTemp = "";
let error = false;
const MESSAGE_LIMIT = 20;
const SCROLL_THRESHOLD = 100;
let page = 1;
let isLoading = false;
let hasMore = true;
let totalPages = 1;
export default function QuestionBankTransfer({
  alreadySelectedQuestions,
  handleNewQuestionTransfer,
  handleSelectedQuestionRemoval,
  blankQuestion,
  setBlankQuestion,
}) {
  const theme = useTheme();
  const [questionBankSearch, setQuestionBankSearch] = useState("");
  const [questionSearch, setQuestionSearch] = useState("");
  const [searchParam] = useState(["questionString"]);
  const [questions, setQuestions] = useState([]);
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [removedQuestions, setRemovedQuestions] = useState([]);
  const listContainerRef = useRef(null);
  const intervalRef = useRef(null);
  const [addQuestionbankDialog, setAddQuestionbankDialog] = useState(false);

  const queryUrl =
    BaseURL.baseUrl +
    BaseURL.templateTool.GetQuestionsFromQuestionBank +
    "pageNumber=1&pageSize=12&searchValue=Add";
  let interval;

  const handleOnSearchChange = (value) => {
    // if (interval) clearTimeout(interval);
    setQuestionBankSearch(value.target.value);
    // setIsListRendered(false);
    totalPages = 1;
    hasMore = true;
    page = 1;
    isLoading = false;

    if (intervalRef.current) {
      clearTimeout(intervalRef.current);
    }

    intervalRef.current = setTimeout(() => {
      setQuestions([]);
      fetchQbQuestions(value.target.value);
    }, 1000);
  };
  searchValueTemp = questionBankSearch;
  const fetchQbQuestions = async (searchValue) => {
    searchValue = searchValue ?? searchValueTemp;
    if (isLoading || !hasMore) return;
    isLoading = true;
    error = false;
    try {
      const response = await axios.get(
        BaseURL.templateTool.GetQuestionsFromQuestionBank +
          "searchValue=" +
          searchValue +
          "&pageSize=" +
          MESSAGE_LIMIT +
          "&pageNumber=" +
          page
      );

      if (response.status == 200) {
        if (response.data.data) {
          setQuestions((prevQuestions) => {
            // remove any duplicates from the new questions before adding them to the existing array
            const newQuestions = response.data.data.filter(
              (question) =>
                !prevQuestions.some(
                  (prevComm) =>
                    prevComm.questionBankId === question.questionBankId
                )
            );
            totalPages = Math.ceil(response.data?.count / MESSAGE_LIMIT);
            return [...prevQuestions, ...newQuestions];
          });
          if (response.data?.data?.length === 0) hasMore = false;

          isLoading = false;
          if (page === 1) {
            const _blank = response.data.data.find(
              (r) => r.questionString === ""
            );
            if (!blankQuestion?.questionBankId > 0)
              _blank && setBlankQuestion(_blank);
          }
        }
      }
    } catch (e) {
      console.error(e);
      error = true;
      isLoading = false;
    }
  };

  const assignToSelectedQuestions = () => {
    const _selectedQuestions = [...selectedQuestions];
    let newlyAdded = [];
    questions.forEach((question, index) => {
      if (question.selected === true) {
        // const isQuestionExists = _selectedQuestions.some(
        //   (selectedQuestion) =>
        //     selectedQuestion.questionBankId === question.questionBankId
        // );

        question.selected = false;
        newlyAdded.push(question);
        _selectedQuestions.push(question);

        // if (!isQuestionExists) {
        //   question.selected = false;
        //   _selectedQuestions.push(question);
        //   newlyAdded.push(question);
        // } else {
        //   question.selected = false;
        // }
        // console.log(question);
      }
      question.index = index;
    });
    setSelectedQuestions(_selectedQuestions);
    if (newlyAdded) handleNewQuestionTransfer(newlyAdded);
  };

  const handleScroll = () => {
    const container = listContainerRef.current;
    const scrolledToBottom =
      container.scrollTop + container.clientHeight >=
      container.scrollHeight - SCROLL_THRESHOLD;
    if (scrolledToBottom) {
      if (!isLoading) {
        if (totalPages >= page) {
          page = page + 1;
          fetchQbQuestions();
        }
      }
    }
  };
  useEffect(() => {}, []);

  useEffect(() => {
    totalPages = 1;
    hasMore = true;
    page = 1;
    isLoading = false;

    const _alreadySelected = alreadySelectedQuestions?.map((item, index) => {
      return {
        index: index,
        questionBankId: item.questionBankId,
        questionReference: item.checklistQuestionId,
        checklistQuestionId: item.checklistQuestionId,
        questionReferenceId: null,
        questionString: item.checklistQuestionText,
        questionStatus: item.questionStatus,
        // preSaved: false,
        preSaved: item.checklistQuestionId > 0,
        usedFor: 0,
        hasUserInput: item.hasUserInput ?? false,
      };
    });

    //console.log(alreadySelectedQuestions, _alreadySelected);
    setSelectedQuestions(_alreadySelected);

    fetchQbQuestions();
    const container = listContainerRef.current;
    container.addEventListener("scroll", handleScroll);
    return () => {
      isLoading = true;
      container.removeEventListener("scroll", handleScroll);
    };
  }, [alreadySelectedQuestions]);
  const addBlankQuestion = () => {
    if (blankQuestion) {
      let newlyAdded = [];
      newlyAdded.push(blankQuestion);
      handleNewQuestionTransfer(newlyAdded);
    } else {
      console.error("No Blank question found.");
    }
  };

  const removeFromSelectedQuestions = () => {
    const updatedQuestions = selectedQuestions.filter((question) => !question.selected);
    setSelectedQuestions(updatedQuestions);
    // I want questions which are removed after above filtering
    // Identify removed questions by comparing the arrays
    const removedQuestions = selectedQuestions.filter(
      (question) => !updatedQuestions.includes(question)
    );

    //console.log("Removed Questions:", removedQuestions);
    handleSelectedQuestionRemoval(removedQuestions);

    const questionBankIdsToRemove = removedQuestions.map(
      (x) => x.questionBankId
    );
  };

  const handleToggleAdd = (value, selected) => {
    let newArr = [];
    let _selectedQuestions = (newArr = _.cloneDeep(questions));
    // if (selectedQuestions.length === 0)
    newArr = _.cloneDeep(questions);
    // else newArr = _.cloneDeep(selectedQuestions);
    newArr.find((r) => r.questionBankId === value).selected = selected;

    setQuestions(newArr);
  };

  const handleToggleRemove = (value, selected, index) => {
    let newArr = [];
    newArr = _.cloneDeep(selectedQuestions);
    // newArr.find((r) => r.questionBankId === value).selected = selected;
    newArr[index].selected = selected;
    setSelectedQuestions(newArr);
  };
  const handleDialogClose = (questionBankObj) => {
    setAddQuestionbankDialog(false);
    if (questionBankObj?.questionBankId > 0) {
      handleNewQuestionTransfer([questionBankObj]);
    }
  };
  return (
    <div className="bg-white w-100 mx-0 border rounded p-0">
      {addQuestionbankDialog && (
        <AddQuestionBankDialog handleDialogClose={handleDialogClose} />
      )}
      <h3
        className="p-4 py-3 border-bottom m-0"
        style={{ color: "rgb(0,0,0)" }}
      >
        CheckList Questions
      </h3>

      <div className="d-lg-flex gap-3 justify-content-evenly p-4 text-align-center">
        <div className="w-100 p-0 border rounded">
          <div className="p-3 pb-0">
            <TextField
              placeholder="Search..."
              className="w-100"
              variant="outlined"
              size="small"
              value={questionBankSearch}
              onChange={handleOnSearchChange}
            />
            <Box
              className="list overflow-auto"
              ref={listContainerRef}
              sx={{
                padding: 1,
                overflowY: "auto",
                minHeight: "190px",
                maxHeight: "206px",
                // height: "230px",
                // marginBottom: 1,
                // backgroundColor: "#fff",
              }}
            >
              <List dense>
                {questions
                  ?.filter((r) => r.questionString !== "")
                  ?.map((r, i) => {
                    return (
                      <QuestionsBankListItem
                        index={i}
                        key={i}
                        questionText={r.questionString}
                        bankId={r.questionBankId}
                        handleToggleAdd={handleToggleAdd}
                        handleToggleRemove={handleToggleRemove}
                        isRemove={false}
                        isSelected={r.selected ?? false}
                        isDisabled={r?.disabled}
                      />
                    );
                  })}
              </List>
            </Box>
          </div>
          <div className="border-top w-100 p-2 d-flex justify-content-between ">
            <ButtonV1
              role="linkBlue"
              size="default"
              trailingComponent={<AddIcon />}
              label="Add Question"
              onClick={() => {
                setAddQuestionbankDialog(true);
              }}
            />

            {/* <Button disabled startIcon={<DeleteOutlineIcon />} color="error">
              Delete Blank
            </Button> */}
          </div>
        </div>
        <div className="d-flex flex-column">
          <IconButton
            className="p-3 border rounded m-1"
            onClick={assignToSelectedQuestions}
          >
            <ArrowForwardIosIcon />
          </IconButton>
          <IconButton
            className="p-3 border rounded m-1"
            onClick={removeFromSelectedQuestions}
          >
            <ArrowBackIosNewIcon />
          </IconButton>
        </div>
        <div className="w-100 border p-3 pb-0 rounded">
          <TextField
            id="outlined-basic"
            className="w-100"
            placeholder="Search..."
            variant="outlined"
            size="small"
            value={questionSearch}
            onChange={(e) => setQuestionSearch(e.target.value)}
          />

          <Box
            sx={{
              overflowY: "auto",
              height: "250px",
            }}
          >
            <List dense>
              {searchright(selectedQuestions)?.filter(r => {
                return r.questionString !== "" 
              })
                // ?.filter((r, index, array) => {
                //   // Filter based on unique questionString
                //   return (
                //     r.questionString !== "" &&
                //     array.findIndex(
                //       (item) => item.questionString === r.questionString
                //     ) === index
                //   );
                // })
                ?.map((r, i) => {
                  return (
                    <QuestionsBankListItem
                      index={i}
                      key={i}
                      questionText={r.questionString}
                      bankId={r.questionBankId}
                      handleToggleAdd={handleToggleAdd}
                      handleToggleRemove={handleToggleRemove}
                      isRemove={true}
                      isDisabled={r?.hasUserInput}
                      isSelected={r.selected ?? false}
                    />
                  );
                })}
            </List>
          </Box>
        </div>
      </div>
    </div>
  );

  function searchright(questionsData) {
    return questionsData?.filter((item) => {
      return searchParam?.some((newItem) => {
        return (
          item[newItem]
            ?.toString()
            .toLowerCase()
            .indexOf(questionSearch.toLowerCase()) > -1
        );
      });
    });
  }
}
